import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { AuthProvider } from 'auth/AuthProvider';
import { queryClient } from 'core/api/queryClient';
import { I18nProvider } from 'core/i18n/I18nProvider';
import { applyDocumentLocale } from 'core/i18n/localeStore';
import { ConfirmProvider } from 'shared/components/ConfirmDialog';
import { ToastProvider } from 'shared/components/Toast';
import App from './App';
import '@fontsource/tajawal/400.css';
import '@fontsource/tajawal/500.css';
import '@fontsource/tajawal/700.css';
import '@fontsource/tajawal/800.css';
import './index.css';
import reportWebVitals from './reportWebVitals';

applyDocumentLocale();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <I18nProvider>
        <AuthProvider>
          <ToastProvider>
            <ConfirmProvider>
              <App />
            </ConfirmProvider>
          </ToastProvider>
        </AuthProvider>
      </I18nProvider>
    </QueryClientProvider>
  </React.StrictMode>,
);

reportWebVitals();
